import {
    ScrollView,
    View,
    ActivityIndicator
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";

import {
    ReturnButton
} from "../../../custom-packages/react-button-package/ButtonPackage.jsx";

import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import PollQuestion from "../../../models/poll/PollQuestion";
import AppConfig from "../../../AppConfig";

const TPollResponseScreen = {
    // English
    "enUS": {
        // FOR POLLING
        'RETURN': 'Return to results',
        'TITLE': 'Poll sent',
        'TERRIBLE': "Terrible",
        'BAD': "Bad",
        'NEUTRAL': "Neutral",
        'GOOD': "Good",
        'EXCELLENT': "Excellent",
        'AVERAGE': "Average",
        'POLL_DETAILS': "See this poll",
    },
    // Spanish
    "esMX": {
        // FOR POLLING
        'RETURN': 'Regresar al reporte',
        'TITLE': 'Encuesta respondida',
        'TERRIBLE': "Terrible",
        'BAD': "Malo",
        'NEUTRAL': "Neutral",
        'GOOD': "Bueno",
        'EXCELLENT': "Excelente",
        'AVERAGE': "Promedio",
        'POLL_DETAILS': "Ver esta encuesta",
    }
}

const PollResponseScreen = () => {
    // @ts-ignore
    const auth = useSelector(state => state.Auth)
    const params = useParams()
    const navigate = useNavigate()
    const pollResponseID = params.id;

    const [loading, setLoading] = useState(true);

    const [questions, setQuestions] = useState<Array<PollQuestion>>([new PollQuestion()])

    const fetchData = async () => {
        setLoading(true)
        const response = await fetch('/Poll/Response/?pollResponseID=' + pollResponseID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.token
            },
        });

        const responseData = await response.json();

        const questions = [...responseData.poll.questions]

        setQuestions(questions)

        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, []);

    if (loading)
        return <ActivityIndicator style={{marginTop: 50}}/>

    return <ScrollView>
        <ReturnButton
            text={TPollResponseScreen[AppConfig.lang].RETURN}
            onPress={() => {
                navigate(-1)
            }}
        />
        <h1>
            {TPollResponseScreen[AppConfig.lang].TITLE}
        </h1>
        <div
            className={'row'}
        >
            {
                questions.map(item => {

                    return <View
                        key={item.pqu_id}
                        style={{
                            marginBottom: 30
                        }}
                        className={'col-12 col-lg-6'}
                    >
                        <View
                            className={'card'}
                        >
                            <View
                                className={'card-body'}
                            >
                                <h2
                                    style={{
                                        marginBottom: 15
                                    }}
                                >
                                    {item.pqu_question}
                                </h2>
                                <View>
                                    {
                                        item.answers.map(answer => {
                                            return <View>
                                                {
                                                    item.pqu_type == "OPEN" ?
                                                        answer.pra_answer
                                                        :
                                                        <View>
                                                            {
                                                                answer.pra_score === 1 ?
                                                                    <View
                                                                        className={'alert-terrible'}
                                                                    >
                                                                        {TPollResponseScreen[AppConfig.lang].TERRIBLE} (1 / 5)
                                                                    </View>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                answer.pra_score === 2 ?
                                                                    <View
                                                                        className={'alert-bad'}
                                                                    >
                                                                        {TPollResponseScreen[AppConfig.lang].BAD} (2 / 5)
                                                                    </View>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                answer.pra_score === 3 ?
                                                                    <View
                                                                        className={'alert-neutral'}
                                                                    >
                                                                        {TPollResponseScreen[AppConfig.lang].NEUTRAL} (3 / 5)
                                                                    </View>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                answer.pra_score === 4 ?
                                                                    <View
                                                                        className={'alert-good'}
                                                                    >
                                                                        {TPollResponseScreen[AppConfig.lang].GOOD} (4 / 5)
                                                                    </View>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                answer.pra_score === 5 ?
                                                                    <View
                                                                        className={'alert-excellent'}
                                                                    >
                                                                        {TPollResponseScreen[AppConfig.lang].EXCELLENT} (5 / 5)
                                                                    </View>
                                                                    :
                                                                    null
                                                            }
                                                        </View>
                                                }
                                                </View>
                                        })
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                })
            }
        </div>
    </ScrollView>
}

export default PollResponseScreen;